<template>
  <div id="main">
    <div class="left">
      <div class="top">
        <img src="../assets/img/logo2.png" alt="" />
      </div>
      <div class="content">
        <!-- 左侧菜单区域 -->
        <div class="menu customScrollBar">
          <div class="fa-menu" v-for="(menu, index) in menuList" :key="index">
            <div
              :class="{ 'fa-menu-title': true, active: active == menu.path }"
              @click="changeMenu(menu)"
            >
              <img :src="active == menu.path ? menu.icon : menu.icon1" alt="" />
              <span>{{ menu.name }}</span>
            </div>
            <div
              class="fa-menu-child"
              v-if="menu.children && active == menu.path"
            >
              <div
                v-for="(item, ii) in menu.children"
                :class="{ 'chi-menu': true, active: childActive == item.path }"
                :key="ii"
                @click="changeMenuItem(item, menu.path)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="fix"></div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="top">
        <div class="word">合肥城市学院普通高校专升本招生管理系统</div>
        <div class="ext">
          <span class="time">{{ time }}</span>
          <!-- <span @click="exit"> 退出</span> -->
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link"> {{ userName }} </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
              <el-dropdown-item command="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="content">
        <router-view />
      </div>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :dialogData="dialogData.data"
      :buttonArray="dialogData.buttonArray"
      @butClick="butClick"
      @cancelDialog="cancelDialog"
    ></diy_dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [],
      active: "realdata",
      userName: "",
      time: new Date(),
      dialogData: {
        flag: false,
        tempId: "", // 用于临时存储相关ID
        title: "密码修改",
        buttonArray: [
          { name: "确认", active: "sureEditPsw", type: "primary" },
          { name: "取消", active: "cancel", type: "info" },
        ],
        data: [
          { title: "原密码", type: "pwd", value: "", key: "old" },
          { title: "新密码", type: "pwd", value: "", key: "newPwd" },
          { title: "再次输入密码", type: "pwd", value: "", key: "newPwdTwo" },
        ],
      },
    };
  },
  methods: {
    /**
     * 获取当前用户的权限数据
     */
    getAuthorityByRole() {
      let requestData = {
        roleId: sessionStorage.getItem("roleId"),
      };
      this.$request(
        "post",
        "/authority/getAuthorityByRole",
        requestData,
        (data) => {
          this.menuList = this.$baseData.foramtMenuByRole(data);
          if (this.menuList.length == 0) {
            this.$message({
              message: "您没有权限,请联系系统管理员!",
              type: "error",
            });
            this.$router.push("/");
            return;
          }
          this.active = sessionStorage.getItem("active")
            ? sessionStorage.getItem("active")
            : "";
          this.childActive = sessionStorage.getItem("childActive")
            ? sessionStorage.getItem("childActive")
            : "";
          this.time = this.$formatTime(new Date(), "YYYY 年 MM 月 DD 日");
          this.userName = sessionStorage.getItem("name");
          this.showModel();
        }
      );
    },
    showModel() {
      if (this.active == "" || this.active == null) {
        this.changeMenu(this.menuList[0]);
        this.active = this.menuList[0].path;
      }
    },
    changeMenu(menu) {
      if (menu.children && menu.children.length > 0) {
        this.active = menu.path;
        sessionStorage.setItem("active", menu.path);
        this.changeMenuItem(menu.children[0], menu.path);
      } else {
        if (menu.path == "") {
          // this.$message({
          //   message: "功能暂未开发!",
          //   type: "warning",
          // });
          return;
        }
        this.active = menu.path;
        sessionStorage.setItem("active", menu.path);
        this.$router.push("/main/" + menu.path);
      }
    },
    changeMenuItem(item, path) {
      console.log("模块下的子模块", item, path);
      if (item.path == "") {
        // this.$message({
        //   message: "功能暂未开发!",
        //   type: "warning",
        // });
        return;
      }
      this.childActive = item.path;
      sessionStorage.setItem("childActive", item.path);
      this.$router.push("/main/" + item.path);
    },
    handleCommand(command) {
      switch (command) {
        case "changePwd":
          this.dialogData.data = [
            { title: "原密码", type: "pwd", value: "", key: "old" },
            { title: "新密码", type: "pwd", value: "", key: "newPwd" },
            { title: "再次输入密码", type: "pwd", value: "", key: "newPwdTwo" },
          ];
          this.dialogData.flag = true;
          break;
        case "exit":
          sessionStorage.clear();
          this.$router.push("/");
          break;

        default:
          break;
      }
    },
    butClick(active) {
      switch (active) {
        case "cancel":
          this.cancelDialog();
          break;
        case "sureEditPsw":
          // 判断非空
          let notNulol = true;
          let requestData = {
            id: sessionStorage.getItem("operatorID"),
          };
          this.dialogData.data.forEach((element) => {
            if (element.value == "") {
              notNulol = false;
            }
            this.$set(requestData, element.key, element.value);
          });
          if (!notNulol) {
            this.$message({
              message: "密码不可为空!",
              type: "error",
            });
            return;
          }
          // 判断新密码与老密码不可相同
          if (requestData.old == requestData.newPwd) {
            this.$message({
              message: "新密码与老密码不可相同!",
              type: "error",
            });
            return;
          }
          // 判断输入的两次新密码相同
          if (requestData.newPwd != requestData.newPwdTwo) {
            this.$message({
              message: "两次密码输入不同!",
              type: "error",
            });
            return;
          }
          this.$request("post", "/user/editPsw", requestData, (data) => {
            this.$message({
              message: "密码修改成功!",
              type: "success",
            });
            sessionStorage.clear();
            this.$router.push("/");
          });
          break;

        default:
          break;
      }
    },
    cancelDialog() {
      this.dialogData.flag = false;
    },
  },
  mounted() {
    this.getAuthorityByRole();
  },
};
</script>

<style lang="less" scoped>
#main {
  width: 100%;
  height: 100%;
  display: flex;

  .left {
    width: 14.5%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    .top {
      width: 100%;
      height: 12%;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      border-bottom: 1px solid #eee;
      > img {
        width: 250px;
        height: 50px;
      }
    }
    .content {
      width: 100%;
      height: 88%;

      > .menu {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        > .fa-menu {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          > .fa-menu-title {
            width: 100%;
            height: 65px;

            display: flex;
            align-items: center;
            padding-left: 15%;
            box-sizing: border-box;
            color: #3d3d3d;
            font-size: 15px;
            transition: 0.1s;
            &:hover {
              cursor: pointer;
              color: #ffffff;
              background: linear-gradient(
                90deg,
                rgba(0, 118, 252, 0.05) 0%,
                rgba(0, 118, 252, 1) 100%
              );
            }
            > img {
              width: 24px;
              height: 24px;
              margin-right: 60px;
            }
          }
          > .active {
            box-sizing: border-box;
            padding-left: 15%;
            background: linear-gradient(
              90deg,
              rgba(0, 118, 252, 0.05) 0%,
              rgba(0, 118, 252, 1) 100%
            );
            color: #fff;
            position: relative;
            &:hover {
              color: #fff;
            }
            > img {
              margin-right: 60px;
            }
          }
          > .fa-menu-child {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            background-color: #d0e8fd1a;
            > .chi-menu {
              width: 100%;
              height: 60px;
              display: flex;
              padding-left: 30%;
              box-sizing: border-box;
              align-items: center;
              color: #3d3d3d;
              font-size: 15px;
              transition: 0.3s;
              &:hover {
                cursor: pointer;
                color: #85b9e8;
              }
            }
            > .active {
              color: #85b9e8;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .right {
    width: 85.5%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .top {
      width: 100%;
      height: 12%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgba(0, 118, 252, 1);
      box-sizing: border-box;
      padding: 0 40px;
      .word {
        font-size: 24px;
        font-weight: 400;
        letter-spacing: 5px;
        color: rgba(255, 255, 255, 1);
      }
      .ext {
        color: #fff;
        span:nth-last-child(1) {
          cursor: pointer;
        }
        .time {
          font-size: 14px;
          margin-right: 20px;
        }
      }
    }
    .content {
      width: 100%;
      height: 88%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(245, 245, 245, 1);
      box-sizing: border-box;
      padding: 32px;
    }
  }
  .fix {
    flex: 1;
  }
  .ret {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;

    cursor: pointer;
    padding: 0 10px;
    box-sizing: border-box;
    transition: 0.3s;
    font-size: 12px;
    &:hover {
      color: #85b9e8;
    }
    > i {
      margin-right: 10px;
    }
  }
  .el-dropdown-link {
    color: #fff;
  }
}
</style>
